export class Application {
  url: string;
  body?: any;
  name: string;
  topLevelRedirect: boolean;
  usePostMessage: boolean;

  constructor(
    url: string,
    body: any,
    name: string,
    topLevelRedirect: boolean,
    usePostMessage?: boolean
  ) {
    this.url = url;
    this.body = body;
    this.name = name;
    this.topLevelRedirect = topLevelRedirect;
    this.usePostMessage = !!usePostMessage;
  }
}
